const AUTH_ALERT_MAP = [
  {
    match: (msg) => msg === "invalid data",
    key: "auth.alerts.invalidData",
  },
  {
    match: (msg) => msg === "invalid credentials",
    key: "auth.alerts.invalidCredentials",
  },
  {
    match: (msg) => msg.includes("please verify your email"),
    key: "auth.alerts.verifyEmailToLogin",
  },
  {
    match: (msg) => msg === "try again",
    key: "auth.alerts.tryAgain",
  },
  {
    match: (msg) => msg === "user data found" || msg === "user data found.",
    key: "auth.alerts.userDataFound",
  },
  {
    match: (msg) => msg.includes("pending activation"),
    key: "auth.alerts.accountPending",
  },
  {
    match: (msg) => msg.includes("account is inactive"),
    key: "auth.alerts.accountInactive",
  },
  {
    match: (msg) => msg.includes("no role assigned"),
    key: "auth.alerts.noRoleAssigned",
  },
  {
    match: (msg) => msg.includes("request data is empty"),
    key: "auth.alerts.requestDataEmpty",
  },
  {
    match: (msg) => msg.includes("data validation errors"),
    key: "auth.alerts.validationErrors",
  },
  {
    match: (msg) => msg.includes("user did not signup"),
    key: "auth.alerts.signupFailed",
  },
  {
    match: (msg) => msg.includes("under review"),
    key: "auth.alerts.underVerification",
  },
  {
    match: (msg) => msg.includes("something went wrong on signup"),
    key: "auth.alerts.signupError",
  },
  {
    match: (msg) => msg.includes("invalid email address"),
    key: "auth.alerts.invalidEmail",
  },
  {
    match: (msg) => msg.includes("first name and last name are required"),
    key: "auth.alerts.nameRequired",
  },
  {
    match: (msg) => msg.includes("email is already verified"),
    key: "auth.alerts.emailAlreadyVerified",
  },
  {
    match: (msg) =>
      msg.includes("otp sent successfully") ||
      msg === "otp sent successfully!",
    key: "auth.alerts.otpSent",
  },
  {
    match: (msg) => msg.includes("email and otp are required"),
    key: "auth.alerts.emailOtpRequired",
  },
  {
    match: (msg) =>
      msg.includes("otp is invalid") || msg.includes("provided otp is invalid"),
    key: "auth.alerts.otpInvalid",
  },
  {
    match: (msg) => msg.includes("otp has expired"),
    key: "auth.alerts.otpExpired",
  },
  {
    match: (msg) =>
      msg.includes("email successfully verified") ||
      msg.includes("otp verified successfully"),
    key: "auth.alerts.emailVerified",
  },
  {
    match: (msg) => msg === "user not found" || msg === "user not found.",
    key: "auth.alerts.userNotFound",
  },
  {
    match: (msg) => msg.includes("password reset email sent"),
    key: "auth.alerts.resetEmailSent",
  },
  {
    match: (msg) => msg.includes("token and new passwords are required"),
    key: "auth.alerts.tokenPasswordRequired",
  },
  {
    match: (msg) =>
      msg.includes("passwords do not match") ||
      msg.includes("passwords don't match"),
    key: "auth.alerts.passwordsDoNotMatch",
  },
  {
    match: (msg) => msg.includes("invalid or expired password reset token"),
    key: "auth.alerts.invalidResetToken",
  },
  {
    match: (msg) => msg.includes("password reset token has expired"),
    key: "auth.alerts.resetTokenExpired",
  },
  {
    match: (msg) => msg.includes("password has been reset successfully"),
    key: "auth.alerts.passwordResetSuccess",
  },
  {
    match: (msg) => msg.includes("internal server error"),
    key: "auth.alerts.internalServerError",
  },
];

/**
 * Map known English auth API alert strings to localized copy.
 * Falls back to the original message, then a generic error.
 */
export const translateAuthApiMessage = (message = "", t) => {
  const normalized = String(message || "")
    .toLowerCase()
    .trim();

  if (!normalized) {
    return t("auth.alerts.genericError", "Something went wrong. Please try again.");
  }

  const entry = AUTH_ALERT_MAP.find((item) => item.match(normalized));
  if (entry) {
    return t(entry.key);
  }

  return message;
};
